import { render, staticRenderFns } from "./left_store_info_goods.vue?vue&type=template&id=b11c3dcc&scoped=true"
import script from "./left_store_info_goods.vue?vue&type=script&lang=js"
export * from "./left_store_info_goods.vue?vue&type=script&lang=js"
import style0 from "./left_store_info_goods.vue?vue&type=style&index=0&id=b11c3dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11c3dcc",
  null
  
)

export default component.exports